module.exports = __webpack_public_path__ + "media/flags/ro-493e60b2.svg";